export const imageSharpQueryToImgObjects = (edges) =>
  edges.map((edge) => ({
    source: {
      // thumbnail: edge.node.childImageSharp.fluid.src,
      // regular: edge.node.childImageSharp.fixed.src,
      regular: edge.node.childImageSharp.fluid.src,
    },
  }))
